import { render, staticRenderFns } from "./SpiriTual.vue?vue&type=template&id=c89a9f98&"
import script from "./SpiriTual.vue?vue&type=script&lang=js&"
export * from "./SpiriTual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports